import { OS1Provider } from "@os1-platform/console-ui-react";
import "./App.css";
import { useEffect, useState } from "react";
import axios from "axios";
import SettingsPage from "./pages/settings";
import Initiate from "./Initiate";
import LaunchPage from "./pages/launch";

let consoleInstance = null;
export const getConsoleInstance = () => consoleInstance;
function App() {
  const [envVariables, setEnvVariables] = useState(null);
  const [token, setToken] = useState("");
  const [isLaunchPage, setLauchPage] = useState(false);
  const setupAxios = async () => {
    const { data: config } = await axios.get(
      // "https://developsln1.nonprod.fxtrt.io"+
      __dirname + "./settings/config.json",
      {
        responseType: "json",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    setEnvVariables(config);
  };
  const init = async () => {
    await setupAxios();
  };
  useEffect(() => {
    init();
    if (
      window.location.pathname.startsWith("/launch/") ||
      window.location.pathname.startsWith("/launch")
    ) {
      setLauchPage(true);
    }
  }, []);
  const handleConsoleInstanceChange = async (instance) => {
    consoleInstance = instance;
    if (instance) {
      const accessToken =
        await instance.authInitializer.getAuthenticationTokens();
      setToken(accessToken.accessToken);
    }
  };

  return (
    envVariables && (
      <>
        <OS1Provider
          clientId={envVariables.REACT_APP_CLIENT_ID}
          loginRedirectPath={"/settings"}
          logoutRedirectPath={"/settings"}
          appId={envVariables.REACT_APP_APP_ID}
        // devTenantId="developsln1"
        >
          <Initiate setConsole={handleConsoleInstanceChange} />
        </OS1Provider>
        <div className="flex">
          <div className="overflow-y-auto flex-grow pb-8 bg-white">
            <div className="px-7 py-8 h-full">
              {token && <SettingsPage token={token} />}
              {isLaunchPage && <LaunchPage />}
            </div>
          </div>
        </div>
      </>
    )
  );
}
export default App;
